import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungQuellenProps {
    dummy?: any;
}

export interface DatenverwaltungQuellenState {
    dummy?: any;
}

export class DatenverwaltungQuellen extends React.Component<DatenverwaltungQuellenProps, DatenverwaltungQuellenState> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_QUELLEN}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_QUELLEN)}
                    showColumnsHelp={true}
                />
            </div>
        );
    }
}
